import React, { useState, Dispatch, SetStateAction, FC } from 'react'
import Uploader from './Uploader'
import NoResults from './NoResults'
import ImageGallery from './ImageGallery'
import EditIcon from 'svg/edit-v3.svg'
import { useSelector } from 'react-redux'
import { getInsideTheStudioImages, getAccountUserID } from '../../selectors'
import { getUserID } from 'selectors/user/session'
import styles from '../aboutArtist/AboutArtist.module.scss'
type InsideTheStudioProps = {
  showUploader: boolean
  setShowUploader: Dispatch<SetStateAction<boolean>>
}

const InsideTheStudio: FC<InsideTheStudioProps> = (props: InsideTheStudioProps) => {
  const { showUploader, setShowUploader } = props
  const additionalImages = useSelector(getInsideTheStudioImages)
  const sessionUserID = useSelector(getUserID)
  const accountUserID = useSelector(getAccountUserID)
  const isMyAccount = sessionUserID === accountUserID
  const [studioImages, setStudioImages] = useState(additionalImages)

  if (studioImages.length === 0 && !isMyAccount) {
    return null
  }

  return (
    <div data-section='inside-the-studio'>
      <div data-type='title-row'>
        {isMyAccount && !showUploader && studioImages.length ? (
          <button
            className={styles.editHeroIcon}
            type='button'
            onClick={() => setShowUploader(!showUploader)}
          >
            <EditIcon />
            <p>Edit Photos</p>
          </button>
        ) : (
          ''
        )}
      </div>
      {isMyAccount && studioImages.length === 0 && !showUploader && (
        <NoResults showUploader={showUploader} setShowUploader={setShowUploader} />
      )}
      {studioImages.length > 0 && !showUploader && <ImageGallery studioImages={studioImages} />}
      {showUploader && (
        <Uploader
          setShowUploader={setShowUploader}
          setStudioImages={setStudioImages}
          additionalImages={studioImages}
        />
      )}
    </div>
  )
}

export default InsideTheStudio
